module.exports = __webpack_public_path__ + "fonts/HKNova-Bold.f38b0c18.woff2";